import { FC } from "react";
import { MonitorLiveDaMesModel } from "../../../../api/live-monitor/models";
import { useIntl } from "react-intl";
import {
  formatMonitorTime,
  formatDateStringToTime,
  formattaPezziOra,
  formattaTeorico,
  getStatusColor,
  getStatusName,
  pezziOraVisualizzabili,
  teoricoVisualizzabile,
} from "./functions";
import { MONITOR_LIVE_PRESSA_STATUSES } from "./constants";

const InfoOperatore: FC<{
  title: String;
  operatore?: String;
  ultimoAttrezzista?: String;
  primoOperatore?: String;
  className?: string;
}> = ({ title, operatore, ultimoAttrezzista, primoOperatore, className }) => {
  // const headerOperatore = operatore ? title : "";
  const nomeOperatore = operatore ? operatore : "";
  // const nomeUltimoAttrezzista = ultimoAttrezzista ? ultimoAttrezzista : "";
  const style = { fontSize: 17, marginBottom: 0 };

  return (
    <div className={className}>
      {/* <h3 className="text-white" style={style}>
        {headerOperatore.toUpperCase()}
      </h3> */}
      <h1 className="text-white" style={style}>
        {nomeOperatore}
        {/* {nomeUltimoAttrezzista && (
          <>
            &nbsp;/&nbsp;
            {nomeUltimoAttrezzista}
          </>
        )} */}
      </h1>
    </div>
  );
};

const MonitorSinglePressDaMesHD: FC<{
  item: MonitorLiveDaMesModel;
}> = ({ item }) => {
  const intl = useIntl();
  const statusColor = getStatusColor(item.stato_def);

  return (
    <div className="col-3">
      <div className="card card-xl-stretch_ mb-4">
        <div
          className={`card-body px-5 pt-3 p-5 p-5 pb-2 ${statusColor} card-rounded w-100`}
          style={{
            minHeight: 224,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          <div>
            <h3
              className="m-0 text-white fw-bolder text-center"
              style={{ lineHeight: 0.9, fontSize: 60 }}
            >
              {item.nome}
              <br />
              <small style={{ fontSize: 38 }}>
                {getStatusName(intl, item.stato_def)}
              </small>
            </h3>

            <hr className="mt-3 mb-3 bg-white" />

            <div className="row">
              {/* 17-09-24: Quando c’è la fase di attrezzaggio sul nuovo monitor live, non far comparire il fine commessa.  */}
              {item.stato_def !== MONITOR_LIVE_PRESSA_STATUSES.ATTREZZAGGIO &&
                item.fine_commessa && (
                  <div
                    className="col-6"
                    style={{
                      borderRight: "1px solid #ffffff55",
                    }}
                  >
                    <h3 className="text-white">
                      {intl
                        .formatMessage({ id: "monitor.fine_commessa" })
                        .toUpperCase()}
                    </h3>
                    <h1 className="text-white" style={{ fontSize: 24 }}>
                      {formatDateStringToTime(item.fine_commessa)}
                    </h1>
                  </div>
                )}

              <div className={"col-6"}>
                <h4
                  className="m-0 text-white fw-bolder text-end"
                  style={{ fontSize: 24, paddingBottom: 4 }}
                >
                  {item.stato_def ===
                    MONITOR_LIVE_PRESSA_STATUSES.ATTREZZAGGIO && ( //Attrezzaggio
                    <>{formatMonitorTime(item.tempo_attrezzaggio)}</>
                  )}

                  {pezziOraVisualizzabili(item) && ( //Diverso da "Fermo macchina" e "Attrezzaggio"
                    <div
                      title={intl.formatMessage({
                        id: "monitor.num_pezzi_ora",
                      })}
                    >
                      {formattaPezziOra(item)}
                    </div>
                  )}

                  {/* Togli anche la teorica in stato di attrezzaggio */}
                  {teoricoVisualizzabile(item) && (
                    <div
                      title={intl.formatMessage({
                        id: "monitor.qta_oraria_nominale",
                      })}
                    >
                      {formattaTeorico(item)}
                    </div>
                  )}
                </h4>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <InfoOperatore
                  title={intl.formatMessage({ id: "monitor.operatore" })}
                  operatore={item.operatore}
                  ultimoAttrezzista={item.ultimo_attrezzista}
                  primoOperatore={item.primo_operatore}
                  className={"mt-2 mb-0"}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`p-5 pt-0 pb-0 ${statusColor}`}
          style={{
            minHeight: 84,
            borderBottomLeftRadius: "0.625rem",
            borderBottomRightRadius: "0.625rem",
          }}
        >
          <hr className="m-0 p-0 mb-2 bg-white" />
          <table className="table align-middle gs-0 gy-1 text-white">
            <tbody>
              <tr>
                <td colSpan={2} className="p-0">
                  {item.desc_articolo && (
                    <>
                      <h5 className="text-white mb-1">
                        {intl
                          .formatMessage({ id: "common.article" })
                          .toUpperCase()}
                      </h5>
                      <h6
                        className="mb-0 text-white"
                        style={{
                          lineHeight: 1.24,
                          fontWeight: 500,
                          fontSize: 17,
                        }}
                      >
                        {item.desc_articolo}
                      </h6>
                    </>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MonitorSinglePressDaMesHD;
